import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FarmacoPage } from './farmaco.page';

const routes: Routes = [
  {
    path: '',
    component: FarmacoPage
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FarmacoPageRoutingModule {}
